import React from "react";
import PropTypes from "prop-types";

import tvChartBridgeHtml from "../../../../../lib/TvChartBridge/tvchartbridge.html";

const TvChartBridgeFrame = ({ frameRef, height, onFrameLoad }) => (
  <div className="tv-chart-bridge__frame" style={{ height, width: "100%" }}>
    <iframe
      ref={frameRef}
      src={tvChartBridgeHtml}
      title="TradingView chart bridge"
      style={{ border: "none", width: "100%", height: "100%" }}
      onLoad={onFrameLoad}
    />
  </div>
);

TvChartBridgeFrame.propTypes = {
  frameRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any })
  ]).isRequired,
  height: PropTypes.number,
  onFrameLoad: PropTypes.func.isRequired
};

TvChartBridgeFrame.defaultProps = {
  height: 500
};

export default TvChartBridgeFrame;
